import React from "react";
import CardSection from "./CardSection";
import NavBottomBar from "../../Components/Common/NavBottomBar";
import MobileViewContainer from "../../Components/MobileViewContainer";

const Ticket = () => {
  return (
    <MobileViewContainer>
      <CardSection />
      <NavBottomBar activeBar={2} />
    </MobileViewContainer>
  );
};

export default Ticket;
